import { Collection } from "intake_shared/src/enum";
import db from "../utils/firestore";

export const allAuthenticatedUsers = async () => {
    try {
        const tokenDocsSnapshot = await db
            .collection(Collection.CALENDAR_AUTH_TOKEN)
            .get();

        if (!tokenDocsSnapshot.empty) {
            const users = tokenDocsSnapshot.docs.map((doc) => {
                const data = doc.data();
                return {
                    email: doc.id,
                    isDefault: data.isDefault,
                    dateConnected: data.dateConnected,
                };
            });
            return users;
        } else {
            console.log("No default token documents found");
            return [];
        }
    } catch (err) {
        console.error("Error fetching users:", err);
        return [];
    }
};

export async function markEmailAsDefault(email: string, defaultOption: boolean) {
    try {
        const tokenDocRef = db.collection(Collection.CALENDAR_AUTH_TOKEN).doc(email);

        const tokenDoc = await tokenDocRef.get();

        if (!tokenDoc.exists) {
            console.log("No document found for email:", email);
            return { success: false, message: "Document not found" };
        }

        await tokenDocRef.update({
            isDefault: defaultOption,
        });

        const action = defaultOption ? "marked as default" : "removed from default";

        return { success: true, message: `${email} was successfully ${action}.` };
    } catch (err) {
        console.error("Error updating the default token:", err);
        return { success: false, message: "Error updating the default token." };
    }
}
